import { useState, useEffect } from 'react';
import clubService from '../services/clubService';

export const useClub = (userId) => {
  const [clubs, setClubs] = useState([]);
  const [selectedClub, setSelectedClub] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('🔵 useClub: userId changed to:', userId);
    
    if (userId) {
      loadClubs();
    } else {
      // If no userId, stop loading and set empty clubs
      console.log('⚠️ useClub: No userId provided');
      setClubs([]);
      setLoading(false);
    }
  }, [userId]);

  const loadClubs = async () => {
    console.log('🔵 useClub: Loading clubs for userId:', userId);
    
    try {
      const result = await clubService.getAdminClubs(userId);
      console.log('🔵 useClub: getAdminClubs result:', result);
      
      if (result.success) {
        // Filter out any undefined clubs
        const validClubs = (result.clubs || []).filter(club => club && club.id);
        setClubs(validClubs);
        console.log('✅ useClub: Loaded', validClubs.length, 'clubs');
        
        if (validClubs.length > 0) {
          setSelectedClub(validClubs[0]);
          console.log('✅ useClub: Selected first club:', validClubs[0].name);
        }
      } else {
        console.error('❌ useClub: Failed to load clubs:', result.error);
        setClubs([]);
      }
    } catch (error) {
      console.error('❌ useClub: Error loading clubs:', error);
      setClubs([]);
    } finally {
      setLoading(false);
      console.log('🔵 useClub: Loading complete');
    }
  };

  const createClub = async (name, location) => {
    console.log('🔵 useClub: Creating club:', { userId, name, location });
    
    try {
      const result = await clubService.createClub(userId, name, location);
      console.log('🔵 useClub: createClub result:', JSON.stringify(result, null, 2));
      
      if (result.success && result.club) {
        console.log('✅ useClub: Club created successfully:', result.club);
        
        // Add the new club to the state immediately
        setClubs(prevClubs => [...prevClubs, result.club]);
        setSelectedClub(result.club);
        
        return { success: true, club: result.club };
      } else {
        console.error('❌ useClub: Failed to create club:', result.error);
        return { success: false, error: result.error || 'Failed to create club' };
      }
    } catch (error) {
      console.error('❌ useClub: Error creating club:', error);
      return { success: false, error: error.message || 'Failed to create club' };
    }
  };

  const updateClub = (updatedClub) => {
    if (!updatedClub || !updatedClub.id) {
      console.error('❌ useClub: Invalid club data for update');
      return;
    }
    
    setClubs(clubs.map(c => c.id === updatedClub.id ? updatedClub : c));
    if (selectedClub?.id === updatedClub.id) {
      setSelectedClub(updatedClub);
    }
  };

  return {
    clubs,
    selectedClub,
    setSelectedClub,
    loading,
    createClub,
    updateClub,
    reloadClubs: loadClubs
  };
};